/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from "vue";

require('./bootstrap');

window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('home', require('./components/HomeComponent.vue').default);

/**
 * META
 */

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

/**
 * lazy load
 */
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

/**
 * router
 */
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routes = [
    { path: '/', component: () => import('./views/Entrada'), name: 'entrada' },
    { path: '/quem-somos', component: () => import('./views/QuemSomos'), name: 'quemSomos' },
    { path: '/que-fazemos', component: () => import('./views/QueFazemos'), name: 'queFazemos' },
    { path: '/portfolio', component: () => import('./views/Portfolio'), name: 'portfolio' },
    { path: '/contactos', component: () => import('./views/Contactos'), name: 'contactos' },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    routes, // short for `routes: routes`
    mode: 'history'
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('pagination', require('laravel-vue-pagination'));

const app = new Vue({
    el: '#app',
    router
});
